export const FulfilledMessages: {[key: string]: string} = {
    'basketballTeams/update': 'generic.update',
}